// extracted by mini-css-extract-plugin
export default {"container":"minimap_container__5CWuJ","minimap":"minimap_minimap__6LvnJ","scale_controls":"minimap_scale_controls__1SzO2"};